import { render, staticRenderFns } from "./accountsCost.vue?vue&type=template&id=3b768d85&scoped=true&"
import script from "./accountsCost.vue?vue&type=script&lang=js&"
export * from "./accountsCost.vue?vue&type=script&lang=js&"
import style0 from "./accountsCost.vue?vue&type=style&index=0&id=3b768d85&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b768d85",
  null
  
)

export default component.exports